import React from 'react'
import { Button } from 'semantic-ui-react'

const LiveTracking = ({ onClick, disabled }) => {
  return (
    <Button
      icon="map"
      size="mini"
      color="black"
      onClick={onClick}
      content="Tracking"
      disabled={disabled}
      labelPosition="right"
      style={{ width: 120, margin: 0, marginTop: 5 }}
    />
  )
}

export default LiveTracking



// WEBPACK FOOTER //
// ./src/containers/orders/components/OrderListItem/ActionButtons/LiveTracking.js